/**
 * services for member's settings
 **/
SUGApp.service('globalService', ['$http', 'SUGUtilities', '$q', '$window', '$location', function( $http, SUGUtilities, $q, $window, $location ){

	var globalService = {};

	var defaultTtl = 60000;

	globalService.getDateAndTZFormats = function(){
		return SUGUtilities.APISyncCall( "get", "", "", "m.getDateAndTimeZoneFormats", 15000 );
	};

	globalService.getDateFormatSamples = function( id ){
		return SUGUtilities.APISyncCall( "post", "", {ID:id}, "m.getDateFormatSamples", 15000 );
	};

	globalService.setDateAndTZFormats = function( dateformatid, zoneid, signUpDefault ){
		return 	SUGUtilities.APISyncCall( "post", "", {dateformatid:dateformatid,zoneid:zoneid,signUpDefault:signUpDefault}, "m.saveDateAndTZSettings", 15000 );
	};

	globalService.setSignUpDateAndTZSettings = function( data ){
		return SUGUtilities.APISyncCall( "post", "", data, "w.saveSignUpDateAndTZSettings", 15000 );
	};

	globalService.getCountries = function(){
		return SUGUtilities.APISyncCallWithCaching( "get", "", "", "g.getCountries", 15000 );				
	};

	globalService.getTimeZonesByCountry = function( countrycode ){
		return SUGUtilities.APISyncCall( "post", "", {countrycode:countrycode}, "g.getTimeZonesByCountry", 15000 );
	};

	globalService.getTimeZonesByZoneGroup = function( countrycode, zoneGroupID, includetzshort ){
		var data = {countrycode:countrycode,zoneGroupID:zoneGroupID};
		if( typeof includetzshort !== 'undefined'){ data.includetzshort = includetzshort; }
		return SUGUtilities.APISyncCall( "post", "", data, "g.getTimeZonesByZoneGroup", 15000 );
	};

	globalService.getZoneGroupsByCountry = function( countryCode ){
		return SUGUtilities.APISyncCall( "post", "", {countryCode:countryCode}, "g.getZoneGroupsByCountry", 15000 );
	};

	globalService.getInternationalDateFormats = function(){
		return SUGUtilities.APISyncCall( "get", "", "", "g.getInternationalDateFormats", 15000 );
	};

	globalService.uploadFile = function( uploadUrl, fileObj, destDirectory ){
		if( typeof uploadUrl === 'undefined' || typeof fileObj === 'undefined' || typeof destDirectory === 'undefined' )
			return 'uploadUrl, fileObj, destDirectory are all required.';

        var fd = new FormData();
        	fd.append('file', fileObj );
        	fd.append('directory', destDirectory);
        return $http.post(uploadUrl, fd, {
	            transformRequest: angular.identity,
	            headers: {'Content-Type': undefined}
	        })
	        .success(function( result ){
	        	return result;
	        })
	        .error(function( result ){
	        	return result;
	        });

    };


	globalService.getEventLogByType = function(data){

		return SUGUtilities.APISyncCall( "post", "", data, "g.getEventLogByType", 15000 );
	};

	globalService.hasPermission = function( permission ){
		if( typeof permission == undefined )
			return false;
		else
			return SUGUtilities.APISyncCall( "post", "", permission, "g.hasPermission", 15000 );
	};

	globalService.getMemberSettings = function(data){
		return SUGUtilities.APISyncCall( "post", "", data, "g.getMemberSettings", 15000 );
	};

	globalService.updateMemberSignUpSettings = function(data){
        return SUGUtilities.APISyncCall( "post", "", data, "g.updateMemberSignUpSettings", 15000 );
    };

	globalService.getSetting = function(){
        return SUGUtilities.APISyncCall( "post", "", "", "g.getSetting", 15000 );
    };

	globalService.getGlobalSettings = function(data){
        return SUGUtilities.APISyncCall( "post", "", data, "g.getGlobalSettings", 15000 );
    };

	globalService.saveSetting = function(data){
        return SUGUtilities.APISyncCall( "post", "", data, "g.saveSetting", 15000 );
    };

	globalService.getMemberID = function(){
		return SUGUtilities.APISyncCall( "get", "", "", 'm.getMemberID' );
	};

	globalService.getActualMemberID = function(){
		return SUGUtilities.APISyncCall( "get", "", "", 'm.getActualMemberID' );
	};

	globalService.getMemberInformation = function(data){
		if( SUGUtilities.isUndefinedOrEmptyObject(data) ){
			return SUGUtilities.APISyncCall("get", "", "", "m.getMemberInfo", 15000 );
		} else {
			return SUGUtilities.APISyncCall("post", "", data, "m.getMemberInfo", 15000 );
		}
	};

	globalService.getSettingCategory = function(data){
        return SUGUtilities.APISyncCall( "post", "", data, "g.getSettingCategory", 15000 );
    };

	globalService.checkPermission = function(data){
        return SUGUtilities.APISyncCall( "post", "", data, "g.checkPermission", 15000 );
    };

	globalService.getGlobalVariable = function( data ){
		return SUGUtilities.APISyncCall( "post", "", data, "g.getGlobalVariable", 15000 );
	};
    globalService.getMerchantConfig = function( data ){
        return SUGUtilities.APISyncCall( "post", "", data, "g.getMerchantConfiguration", 15000 );
    };

    globalService.isLoggedIn = function(){
        var deferred = $q.defer();
        globalService.getMemberID().then(function (response) {
            // successfully retrieved member info
            var r = SUGUtilities.lowerCaseKeys(response);
            if(r.data && r.data.code && r.data.code === 1002){
                $window.location.reload();
                deferred.reject(false);
            } else {
                deferred.resolve(true);
            }
        });
        return deferred.promise;
    };

	globalService.isLoggedInWioutRefreshToken = function(){
		return SUGUtilities.APISyncCall( "get", "", "", 'g.isLoggedIn' );
    };

	globalService.checkNewAdDirective = function( data ){
		return SUGUtilities.APISyncCallWithCaching( "post", "", data, "g.useNewAdDirective", 15000 );
	};

	globalService.isFeatureEnabled = function( data ){
		return SUGUtilities.APISyncCall( "post", "", data, "g.isFeatureEnabled", 15000 );
	};

	globalService.getFeatureDetailByName = function( data ){
		return 	SUGUtilities.APISyncCall( "post", "", data, "g.getFeatureDetailByName", 15000 );
	};

	globalService.getFeatureMessageAmounts = function(data){
		return SUGUtilities.APISyncCallWithCaching( "post", "", data, "g.getFeatureMessageAmounts", 15000, defaultTtl );				
	};

	/**
	 * Used to verify page access during AngularJS route resolution (not for security but for improved UX)
	 *
	 * @param  {String} permlist  - The permission(s) to check
	 * @param  {String} failpage - Optional page to redirect to on permission check failure, otherwise directs to the '/' route
	 * @param  {Number} listid - Optional listid to verify access against
	 */
	globalService.checkPageAccess = function(permlist,failpage,listid){
		var deferred = $q.defer();
		globalService.checkPermission({
			permissioncode: permlist
		}).then(function (response) {
			if (!SUGUtilities.ajaxResultInvalid(response)) {
				var r = SUGUtilities.lowerCaseKeys(response);
				// see if we need to validate against a specific listid
				if(SUGUtilities.isIntegerGT0(listid) && r.data.data.authtype && r.data.data.authtype === 'P' && r.data.data.listids){
					var arrListIDs = r.data.data.listids.toString().split(',');
					var matchedAuthID = arrListIDs.some(function(currListID){
						return (+currListID === +listid);
					});
					if(matchedAuthID){
						deferred.resolve(r.data.data);
					} else if (typeof failpage !== 'undefined' && failpage.length) {
						$window.location.href = failpage;
						deferred.reject();
					} else {
						$location.path('/');
						deferred.reject();
					}
				} else {
					deferred.resolve(r.data.data);
				}
			} else if (typeof failpage !== 'undefined' && failpage.length) {
				$window.location.href = failpage;
				deferred.reject();
			} else {
				$location.path('/');
				deferred.reject();
			}
		});
		return deferred.promise;
	};

	globalService.logAdBlockerUsage = function(data){
        return SUGUtilities.APISyncCall( "post", "", data, "c.logAdBlockerUsage", 15000 );
	};
	
	// sanitize for XSS
	globalService.sanitize = function (data) {
		return SUGUtilities.APISyncCall('post', '', data, 'g.sanitize', 15000);
	};

	
	/**
     * 
     * @param {string} data the id of the owner 
     * @returns 
     */
	globalService.getInvisibleReCaptcha = function(data) {	
		return SUGUtilities.APISyncCall("post", "", data, "g.getInvisibleReCaptcha", 15000);
	}

	/** validates a recaptcha token returned by Google's invisible recaptcha
	 * 
	 * @param {string} key - token to validate
	 * @returns 
	 */
	/** method to verify the captcha response **/
	globalService.validateInvisibleReCaptcha = function(key) {
		return SUGUtilities.APISyncCall("post", "", key, "g.validateInvisibleReCaptcha", 15000);
	}
	
	/**
     * 
     * @param {string} data object for the contents to be retrieved 
     * @returns 
     */
	globalService.getLearnMoreContent = function (data) {
        return SUGUtilities.APISyncCall('post', '', data, 'c.getContentByName', 15000)
    };

    // return object
    return globalService;

}]);
